'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
require('../CardColumnWrapper/CardColumnWrapper.js');
var CardColumnWrapperImageWrap = require('../CardColumnWrapper/CardColumnWrapperImageWrap.js');
var CardColumnWrapperImage = require('../CardColumnWrapper/CardColumnWrapperImage.js');
require('../CardColumnWrapper/CardColumnWrapperContent.js');
var HighlightCard = require('./HighlightCard.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children", "className"];

/**
 * HighlightCard image container
 */

var HighlightCardImage = react.forwardRef(function (props, ref) {
  var _useHighlightCardCont = HighlightCard.useHighlightCardContext(),
    status = _useHighlightCardCont.status;
  var Image = HighlightCard.HIGHLIGHT_CARD_STATUSES[status].image;
  var styles = react.useStyles();
  var children = props.children,
    className = props.className,
    rest = _objectWithoutProperties__default["default"](props, _excluded);
  if (!children && !Image) {
    return null;
  }
  return /*#__PURE__*/React__default["default"].createElement(CardColumnWrapperImageWrap.CardColumnWrapperImageWrap, {
    sx: styles.imageWrapStyles,
    className: utils.cx('chakra-highlight-card__img-wrapper', className)
  }, children || /*#__PURE__*/React__default["default"].createElement(CardColumnWrapperImage.CardColumnWrapperImage, _extends__default["default"]({
    ref: ref,
    src: Image
  }, rest, {
    className: utils.cx('chakra-highlight-card__img', className),
    sx: styles.image
  })));
});
HighlightCardImage.displayName = 'HighlightCardImage';
exports.HighlightCardImage = HighlightCardImage;